export default "__VITE_ASSET__CruFMVMu__"